import React from "react";
import "./ComputationScreen.css";

const ComputationScreen = (props) => (
    <div className="ComputationScreen">
    {props.children}
    </div>
  );
  export default ComputationScreen;